'use client';

import { c as _c } from "react/compiler-runtime";
import type { FC, PropsWithChildren } from 'react';
import { ArkProvider } from '@sola/ark-core/contexts/ark.tsx';
import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.tsx';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.ts';
import { SupporterProvider } from '@sola/supporter-sdk/provider.tsx';
export const SkippyProviders: FC<PropsWithChildren<{
  locale?: string;
}>> = t0 => {
  const $ = _c(4);
  const {
    children,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getPublicConfig();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const publicConfig = t1;
  const includeAuthProvider = publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;
  let t2;
  if ($[1] !== children || $[2] !== locale) {
    const content = <ArkProvider locale={locale} loadRandomChild={true}>{children}</ArkProvider>;
    t2 = includeAuthProvider ? <AuthProvider><SupporterProvider>{content}</SupporterProvider></AuthProvider> : content;
    $[1] = children;
    $[2] = locale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};